export const TRIAL_DAYS = 7;

export function getTrialEndsAt(restaurant) {
  if (!restaurant?.trialEndsAt) return null;
  return new Date(restaurant.trialEndsAt);
}

export function isTrialActive(restaurant) {
  if (restaurant?.trialActive) return true;
  if (!restaurant || restaurant.plan !== 'trial') return false;
  const ends = getTrialEndsAt(restaurant);
  return ends ? new Date() < ends : false;
}

export function getTrialDaysRemaining(restaurant) {
  const ends = getTrialEndsAt(restaurant);
  if (!ends) return 0;
  return Math.max(0, Math.ceil((ends.getTime() - Date.now()) / (1000 * 60 * 60 * 24)));
}

export function isTrialRegistration(restaurant, deviceCount) {
  return isTrialActive(restaurant) && deviceCount === 0;
}